import { render } from "./SectionImage.vue?vue&type=template&id=0963742f&scoped=true"
import script from "./SectionImage.vue?vue&type=script&lang=js"
export * from "./SectionImage.vue?vue&type=script&lang=js"

import "./SectionImage.vue?vue&type=style&index=0&id=0963742f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0963742f"]])

export default __exports__